export default "__VITE_ASSET__6546d3e2__"